function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1992(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18.31,
    height: 10.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 5.255
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.51,
    width: 18.31,
    height: 10.51,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5014285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 15.765
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.01,
    width: 18.31,
    height: 10.63,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5185714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 26.325000000000003
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.65,
    width: 18.31,
    height: 11.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 37.489999999999995
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 43.33,
    width: 18.31,
    height: 12.75,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 49.705
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 56.08,
    width: 18.31,
    height: 13.8,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 62.98
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 69.89,
    width: 18.31,
    height: 13.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.063076923076923
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 76.8
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 83.7,
    width: 18.31,
    height: 14.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4916666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 91.175
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 98.65,
    width: 18.31,
    height: 16.93,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.386
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 107.11500000000001
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 115.58,
    width: 18.31,
    height: 19.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 125.375
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 135.17,
    width: 18.31,
    height: 19.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0516666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 145.04999999999998
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 154.93,
    width: 18.31,
    height: 21.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0516666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 165.525
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 176.11,
    width: 18.31,
    height: 22.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.5775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 187.395
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 198.68,
    width: 18.31,
    height: 23.27,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 210.315
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 221.95,
    width: 18.31,
    height: 23.71,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0516666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 233.80499999999998
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 245.67,
    width: 18.31,
    height: 25.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0516666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 258.21
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 270.75,
    width: 18.31,
    height: 25.2,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.28875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 283.35
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 295.95,
    width: 18.31,
    height: 25.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0516666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 308.735
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 321.51,
    width: 18.31,
    height: 27.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.28875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 335.025
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 348.55,
    width: 18.31,
    height: 29.05,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.28875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 363.075
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 377.6,
    width: 18.31,
    height: 30.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.831
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 392.69
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 407.78,
    width: 18.31,
    height: 30.93,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0516666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 423.24499999999995
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 438.71,
    width: 18.31,
    height: 31.4,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0516666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 454.40999999999997
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 470.11,
    width: 18.31,
    height: 31.46,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 485.84000000000003
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 501.57,
    width: 18.31,
    height: 31.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 517.455
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 533.34,
    width: 18.31,
    height: 32.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.662
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 549.6
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 565.87,
    width: 18.31,
    height: 33.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0516666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 582.43
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 598.99,
    width: 18.31,
    height: 33.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.28875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 615.665
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 632.34,
    width: 18.31,
    height: 33.55,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 649.115
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 665.89,
    width: 18.31,
    height: 34.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.155,
    y: 682.9449999999999
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 0,
    width: 22.93,
    height: 27.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.86625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.775,
    y: 13.62
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.24,
    y: 0,
    width: 22.94,
    height: 27.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.588
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.71,
    y: 13.62
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.18,
    y: 0,
    width: 23.43,
    height: 27.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.905
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.89500000000001,
    y: 13.62
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.6,
    y: 0,
    width: 23.44,
    height: 27.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9066666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 99.32,
    y: 13.62
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.04,
    y: 0,
    width: 24.47,
    height: 27.24,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4957142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.275,
    y: 13.62
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.51,
    y: 0,
    width: 24.67,
    height: 27.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.08375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.845,
    y: 13.62
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.17,
    y: 0,
    width: 25.37,
    height: 27.24,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.074
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.855,
    y: 13.62
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.54,
    y: 0,
    width: 25.54,
    height: 27.24,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6485714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.31,
    y: 13.62
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.07,
    y: 0,
    width: 25.85,
    height: 27.24,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.995,
    y: 13.62
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.92,
    y: 0,
    width: 26.25,
    height: 27.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.045,
    y: 13.62
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.17,
    y: 0,
    width: 26.29,
    height: 27.24,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.381666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.315,
    y: 13.62
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.45,
    y: 0,
    width: 26.74,
    height: 27.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 302.82,
    y: 13.62
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.2,
    y: 0,
    width: 26.92,
    height: 27.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.845714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.65999999999997,
    y: 13.62
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.12,
    y: 0,
    width: 27.26,
    height: 27.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.405
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 356.75,
    y: 13.62
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.38,
    y: 0,
    width: 27.94,
    height: 27.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 384.35,
    y: 13.62
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.32,
    y: 0,
    width: 28.45,
    height: 27.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.4479999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.545,
    y: 13.62
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.77,
    y: 0,
    width: 28.7,
    height: 27.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.7239999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.12,
    y: 13.62
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.46,
    y: 0,
    width: 28.71,
    height: 27.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.4479999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 469.815,
    y: 13.62
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484.17,
    y: 0,
    width: 29.5,
    height: 27.24,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.4479999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 498.92,
    y: 13.62
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.66,
    y: 0,
    width: 30.16,
    height: 27.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 528.74,
    y: 13.62
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.83,
    y: 0,
    width: 30.66,
    height: 27.24,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.405
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.1600000000001,
    y: 13.62
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.48,
    y: 0,
    width: 30.7,
    height: 27.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 589.83,
    y: 13.62
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 605.19,
    y: 0,
    width: 31.45,
    height: 27.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 620.9150000000001,
    y: 13.62
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.64,
    y: 0,
    width: 31.56,
    height: 27.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0266666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 652.42,
    y: 13.62
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 668.19,
    y: 0,
    width: 31.81,
    height: 27.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 684.095,
    y: 13.62
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 27.24,
    width: 31.61,
    height: 27.67,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.534000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 41.075
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 54.91,
    width: 31.61,
    height: 28,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 68.91
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 82.91,
    width: 31.61,
    height: 28.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.56875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 97.185
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 111.45,
    width: 31.61,
    height: 28.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.803333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 125.86
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 140.27,
    width: 31.61,
    height: 29.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.1657142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 154.85000000000002
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 169.43,
    width: 31.61,
    height: 29.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 184.155
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 198.89,
    width: 31.61,
    height: 29.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.958333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 213.765
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 228.64,
    width: 31.61,
    height: 29.81,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.72625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 243.545
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 258.45,
    width: 31.61,
    height: 29.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.9783333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 273.385
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 288.32,
    width: 31.61,
    height: 30.34,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3342857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 303.49
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 318.66,
    width: 31.61,
    height: 30.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.174
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 334.095
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 349.53,
    width: 31.61,
    height: 31.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.2250000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 365.205
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 380.88,
    width: 31.61,
    height: 32.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.9025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 396.925
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 412.97,
    width: 31.61,
    height: 32.4,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 429.17
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 445.37,
    width: 31.61,
    height: 33.07,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.161
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 461.90500000000003
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 478.44,
    width: 31.61,
    height: 33.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.515714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 495.255
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 512.08,
    width: 31.61,
    height: 34.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 529.5400000000001
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 547,
    width: 31.61,
    height: 37.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 565.89
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 584.78,
    width: 31.61,
    height: 38.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 603.845
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 622.91,
    width: 31.61,
    height: 38.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.515714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 642.105
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 661.3,
    width: 31.61,
    height: 38.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.95125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.114999999999995,
    y: 680.65
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 27.24,
    width: 33.92,
    height: 36.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.784000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.87,
    y: 45.405
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.83,
    y: 27.24,
    width: 34.22,
    height: 36.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.703333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 100.94,
    y: 45.405
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.05,
    y: 27.24,
    width: 34.33,
    height: 36.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.443333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.215,
    y: 45.405
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.39,
    y: 27.24,
    width: 34.42,
    height: 36.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.6,
    y: 45.405
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.81,
    y: 27.24,
    width: 34.45,
    height: 36.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.890000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.035,
    y: 45.405
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.26,
    y: 27.24,
    width: 34.53,
    height: 36.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.31625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.52499999999998,
    y: 45.405
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.79,
    y: 27.24,
    width: 34.81,
    height: 36.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.867777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.195,
    y: 45.405
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 27.24,
    width: 35.03,
    height: 36.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0042857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.115,
    y: 45.405
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325.62,
    y: 27.24,
    width: 35.06,
    height: 36.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.0120000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.15,
    y: 45.405
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.68,
    y: 27.24,
    width: 35.84,
    height: 36.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.973333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 378.6,
    y: 45.405
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.52,
    y: 27.24,
    width: 35.85,
    height: 36.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9750000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.445,
    y: 45.405
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.37,
    y: 27.24,
    width: 36.48,
    height: 36.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.266
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 450.61,
    y: 45.405
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.85,
    y: 27.24,
    width: 37.22,
    height: 36.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.036666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.46000000000004,
    y: 45.405
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.07,
    y: 27.24,
    width: 37.34,
    height: 36.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.74,
    y: 45.405
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.41,
    y: 27.24,
    width: 37.59,
    height: 36.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.54125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.2049999999999,
    y: 45.405
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 581,
    y: 27.24,
    width: 39.08,
    height: 36.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.633
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.54,
    y: 45.405
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.08,
    y: 27.24,
    width: 39.86,
    height: 36.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.266
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.01,
    y: 45.405
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.94,
    y: 27.24,
    width: 40.06,
    height: 36.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.97,
    y: 45.405
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 63.57,
    width: 39.96,
    height: 36.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.128333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 81.955
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 100.33,
    width: 39.96,
    height: 36.84,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.368
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 118.75
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 137.17,
    width: 39.96,
    height: 38.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 156.17499999999998
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 175.18,
    width: 39.96,
    height: 38.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 194.235
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 213.29,
    width: 39.96,
    height: 38.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 232.515
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 251.74,
    width: 39.96,
    height: 38.67,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.867
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 271.075
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 290.41,
    width: 39.96,
    height: 39.19,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.598571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 310.005
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 329.6,
    width: 39.96,
    height: 39.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 349.38500000000005
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 369.16,
    width: 39.96,
    height: 39.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.978
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 389.105
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 409.06,
    width: 39.96,
    height: 40,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 429.06
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 449.06,
    width: 39.96,
    height: 40.2,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 469.16
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 489.25,
    width: 39.96,
    height: 40.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 509.38
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 529.51,
    width: 39.96,
    height: 41.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.708571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 550.365
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 571.22,
    width: 39.96,
    height: 42.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 592.255
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 613.29,
    width: 39.96,
    height: 42.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 634.62
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 655.95,
    width: 39.96,
    height: 44.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.89,
    y: 677.975
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.87,
    y: 63.57,
    width: 39.61,
    height: 45.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.95125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.67500000000001,
    y: 86.205
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.48,
    y: 63.57,
    width: 41.98,
    height: 45.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.395999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.47,
    y: 86.205
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.46,
    y: 63.57,
    width: 42.6,
    height: 45.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.733333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.76000000000002,
    y: 86.205
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.06,
    y: 63.57,
    width: 42.74,
    height: 45.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.105714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.43,
    y: 86.205
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.8,
    y: 63.57,
    width: 42.76,
    height: 45.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.126666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.18,
    y: 86.205
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.55,
    y: 63.57,
    width: 44.63,
    height: 45.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.1575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 321.865,
    y: 86.205
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.18,
    y: 63.57,
    width: 46.55,
    height: 45.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.545000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.455,
    y: 86.205
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.73,
    y: 63.57,
    width: 47.92,
    height: 45.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.65875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.69,
    y: 86.205
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.65,
    y: 63.57,
    width: 48.61,
    height: 45.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.3175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.955,
    y: 86.205
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.26,
    y: 63.57,
    width: 49.75,
    height: 45.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.3175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 512.135,
    y: 86.205
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 537.01,
    y: 63.57,
    width: 52.29,
    height: 45.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.545000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.155,
    y: 86.205
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.31,
    y: 63.57,
    width: 54.97,
    height: 45.27,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.467142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.795,
    y: 86.205
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 644.28,
    y: 63.57,
    width: 55.72,
    height: 45.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.545000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.14,
    y: 86.205
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.87,
    y: 108.83,
    width: 53.36,
    height: 49.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.55000000000001,
    y: 133.34
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.87,
    y: 157.86,
    width: 53.36,
    height: 50.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.145714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.55000000000001,
    y: 182.87
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.87,
    y: 207.88,
    width: 53.36,
    height: 54.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.893333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.55000000000001,
    y: 234.9
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.87,
    y: 261.92,
    width: 53.36,
    height: 55.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.622857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.55000000000001,
    y: 289.73
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.87,
    y: 317.54,
    width: 53.36,
    height: 58.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.622857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.55000000000001,
    y: 346.68
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.87,
    y: 375.83,
    width: 53.36,
    height: 59.69,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.55000000000001,
    y: 405.67499999999995
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.87,
    y: 435.52,
    width: 53.36,
    height: 62.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.55000000000001,
    y: 466.645
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.87,
    y: 497.77,
    width: 53.36,
    height: 67.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.893333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.55000000000001,
    y: 531.38
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.87,
    y: 564.99,
    width: 53.36,
    height: 67.41,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.672
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.55000000000001,
    y: 598.695
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.87,
    y: 632.4,
    width: 53.36,
    height: 67.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.622857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.55000000000001,
    y: 666.1999999999999
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.23,
    y: 108.83,
    width: 55.65,
    height: 66.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.05499999999998,
    y: 142
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.88,
    y: 108.83,
    width: 65.4,
    height: 66.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.57999999999998,
    y: 142
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.29,
    y: 108.83,
    width: 70.62,
    height: 66.34,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.477142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.6,
    y: 142
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.9,
    y: 108.83,
    width: 70.77,
    height: 66.34,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.371111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.28499999999997,
    y: 142
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 405.67,
    y: 108.83,
    width: 71.87,
    height: 66.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.477142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.605,
    y: 142
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.55,
    y: 108.83,
    width: 72.2,
    height: 66.34,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.2925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.65,
    y: 142
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.75,
    y: 108.83,
    width: 72.97,
    height: 66.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.268
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 586.235,
    y: 142
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 622.72,
    y: 108.83,
    width: 77.28,
    height: 66.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.268
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.36,
    y: 142
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.23,
    y: 175.17,
    width: 81.87,
    height: 68.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.81857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.165,
    y: 209.535
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.23,
    y: 243.9,
    width: 81.87,
    height: 71.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.366
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.165,
    y: 279.815
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.23,
    y: 315.74,
    width: 81.87,
    height: 72.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.08875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.165,
    y: 352.095
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.23,
    y: 388.45,
    width: 81.87,
    height: 74.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.461666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.165,
    y: 425.835
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.23,
    y: 463.22,
    width: 81.87,
    height: 75.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.41625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.165,
    y: 500.88500000000005
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.23,
    y: 538.54,
    width: 81.87,
    height: 79.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.86111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.165,
    y: 578.415
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.23,
    y: 618.3,
    width: 81.87,
    height: 81.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.671428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.165,
    y: 659.15
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.11,
    y: 175.17,
    width: 67.41,
    height: 101.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.8525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.815,
    y: 225.95499999999998
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.51,
    y: 175.17,
    width: 68.06,
    height: 101.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.722857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.53999999999996,
    y: 225.95499999999998
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.57,
    y: 175.17,
    width: 106.58,
    height: 101.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.69625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.86,
    y: 225.95499999999998
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 467.15,
    y: 175.17,
    width: 112.33,
    height: 101.57,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.3925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.3149999999999,
    y: 225.95499999999998
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.48,
    y: 175.17,
    width: 120.52,
    height: 101.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.51
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.74,
    y: 225.95499999999998
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.11,
    y: 276.75,
    width: 140.74,
    height: 89.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.16125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.48,
    y: 321.395
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.11,
    y: 366.03,
    width: 140.74,
    height: 108.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.442857142857141
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.48,
    y: 420.08
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.11,
    y: 474.13,
    width: 140.74,
    height: 225.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.5925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.48,
    y: 587.065
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.84,
    y: 276.75,
    width: 159.67,
    height: 260.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 39.9175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.67499999999995,
    y: 407.07
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.51,
    y: 276.75,
    width: 174.49,
    height: 260.64,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 29.081666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.755,
    y: 407.07
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.84,
    y: 537.38,
    width: 334.16,
    height: 162.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.103333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.92,
    y: 618.69
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1992);
export default __webpack_public_path__ + "static/media/1992.55055e23b3532b531a345c9dbb1a72b7.svg";
export { ForwardRef as ReactComponent };